import { Permissions } from '@/app/types';

export enum modals {
  RESET_PERMISSIONS_MODAL = 'RESET_PERMISSIONS_MODAL',
  RESET_LOCATION_MODAL = 'RESET_LOCATION_MODAL'
}

export type ModalRequest =
  | { modal: modals.RESET_PERMISSIONS_MODAL; permissions: Permissions }
  | { modal: modals.RESET_LOCATION_MODAL };
